import React from "react";
import Footer from "./Footer";
import { Box, SxProps, Theme, ThemeProvider } from "@mui/system";
import themes from "../themes";
import "../layout.css";
import Nav from "./Nav";
import { CssBaseline } from "@mui/material";
import PrivacyPolicy from "./PrivacyPolicy";

const Layout = ({
  inverted,
  children,
  invertedFooter,
  addSpacings = true,
  overrideSpacings = {},
  theme = "light",
}: {
  inverted?: boolean;
  children: React.ReactNode;
  invertedFooter?: boolean;
  addSpacings?: boolean;
  overrideSpacings?: SxProps<Theme>;
  theme?: keyof typeof themes;
}) => {
  return (
    <ThemeProvider theme={themes[theme]}>
      <CssBaseline />
      <PrivacyPolicy />
      <ThemeProvider theme={themes.light}>
        <Nav inverted={inverted} />
      </ThemeProvider>
      <main>
        <Box
          sx={
            addSpacings
              ? {
                  maxWidth: themes[theme].customSpacing?.containerMaxWidth,
                  mt: { xs: "72px", sm: "80px", md: "83px" },
                  px: themes[theme].customSpacing?.marginSide,
                  mb: themes[theme].customSpacing?.marginBottomLarge,
                  mx: "auto",
                  ...overrideSpacings,
                }
              : null
          }
        >
          {children}
        </Box>
      </main>
      <ThemeProvider theme={themes.dark}>
        <Footer inverted={invertedFooter} />
      </ThemeProvider>
    </ThemeProvider>
  );
};

export default Layout;
